import { NormalHeading } from "@root/components/adminDashboard/style";
import CopyFeature from "@root/components/common/button/copyPasteAnimation";
import { CustomText } from "@root/components/common/components";
import {
  CenterFlex,
  StyledAvatar,
} from "@root/components/dashboard/chat/style";
import { useTranslation } from "react-i18next";

export const UserDetailsHeader = ({ user }: any) => {
  const { t } = useTranslation("common");
  return (
    <CenterFlex flexDir={"column"} py={"16px"}>
      <StyledAvatar
        name={user?.fullname }
        width={"60px"}
        height={"60px"}
        src={user?.avatar}
      />
      <NormalHeading pt={"14px"} text={user?.fullname} />
      <CenterFlex gap={"8px"}>
        <CustomText color={"theme.gray.400"} text={user?.email } />
        <CopyFeature text={user?.email || ""} />
      </CenterFlex>
      <CustomText
        color={"theme.gray.400"}
        text={`${t("userDetails.userID")}: ${user?.id}`}
      />
    </CenterFlex>
  );
};
